
const walletStore = useWalletStore();

export const topMenuLinks = computed(() => ([
{
    key: "mints",
    label: "Mints",
    to: "/mints",
    icon: "i-tabler-leaf",
    scheduled: 0,
  },
  {
    key: "wallets",
    label: "Wallets",
    to: "/wallets",
    icon: walletStore.synchronizing ? "i-tabler-refresh-dot" : "i-mingcute-wallet-5-line",
    iconClass: walletStore.synchronizing ? "animate-spin [animation-duration:700ms] opacity-50" : "",
    badge: walletStore.wallets().length,
  },

  {
    key: "disperse",
    label: "Disperse",
    to: "/disperse",
    icon: "i-tabler-topology-star-3",
  },

  // {
  //   key: "agents",
  //   label: "Agents",
  //   to: "agents",
  //   icon: "i-tabler-terminal-2",
  //   disabled: true,
  // },

  // {
  //   key: "calendar",
  //   label: "Calendar",
  //   to: "calendar",
  //   icon: "i-mingcute-calendar-month-line",
  //   disabled: true,
  // }

]));

export const bottomMenuLinks = computed(() => ([
  {
    key: "FAQ",
    label: "FAQ",
    to: "/faq",
    target: "_blank",
    icon: "i-tabler-help"
  },
  {
    key: "support",
    label: "Support",
    to: "https://discord.com/channels/1281586674576654351/1333339771870904423",
    target: "_blank",
    icon: "i-mdi-chat-question-outline"
  },
]));
